import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import PermissionsService, { PERMISSION_COST_CENTERS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CostCentersForm from '../../components/CostCenters/Form';
import { URL_CODEBOOKS, URL_COST_CENTERS } from '../../router/constants';
import { selectedCustomersAtom } from '../../store/jotai/customers';

export const Route = createFileRoute('/_authenticated/system_settings/cost-centers/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST_CENTERS, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'tab.cost-centers',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddCostCenterRoute,
});

function AddCostCenterRoute() {
  const navigate = useNavigate();
  const selectedCustomers = useAtomValue(selectedCustomersAtom);

  const handleClose = React.useCallback(() => {
    navigate({ to: `${URL_CODEBOOKS}${URL_COST_CENTERS}` });
  }, [navigate]);

  if (!PermissionsService.hasAccess(PERMISSION_COST_CENTERS, ['create'], selectedCustomers)) {
    return null;
  }

  return <CostCentersForm id={null} customerId={null} handleClose={handleClose} />;
}
